"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: 'Выберите время',
  rangePlaceholder: ['Время начала', 'Время окончания']
};
var _default = exports.default = locale;